import staticPageBodyMarkdown from './staticPageExample.md?raw';

export const staticPageTitle = 'Static Page Example';

export const staticPageMarkdown = staticPageBodyMarkdown.trim();
